
namespace Gamification.Gamification {
    export class ApiColumns {
        static columnsKey = 'Gamification.Api';
    }
}